import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { always, cond, equals, isEmpty, T } from 'ramda';

import messages from './filterModal.messages';
import { Dialog, Header, Heading, Content, ScrollContent, Controls, Control } from './filterModal.styles';
import { BodyScrollLock } from '../bodyScrollLock';
import { ModalOverlay } from '../modalOverlay';
import { renderWhenTrue, renderWhenTrueOtherwise } from '../../utils/rendering';

import {
  DEFAULT_DATE_FILTER_DATA,
  DEFAULT_FILTER_DATA,
  DEFAULT_FILTER_NAME,
  FilterNames,
} from '../../../modules/filters/filters.constants';
import { FilterModalLocation } from './filterModalLocation';
import { FilterModalActivities } from './filterModalActivities';
import { FilterModalGuests } from './filterModalGuests';
import { FilterModalDatePicker } from './filterModalDatePicker';
import { FADE_IN_UP_TRANSITION_TOTAL_DURATION } from '../animated/animated.constants';

export class FilterModal extends PureComponent {
  static propTypes = {
    className: PropTypes.any,
    contentStyle: PropTypes.any,
    currentFilterName: PropTypes.string,
    currentFilter: PropTypes.object,
    isModalVisible: PropTypes.bool,
    animateModalByFilterName: PropTypes.func.isRequired,
    setFilterDataByFilterName: PropTypes.func.isRequired,
  };

  state = {
    touched: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.currentFilterName !== this.props.currentFilterName) {
      this.setState({ touched: false });
    }
  }

  getIsClearButtonVisible = () => {
    const { data } = this.props.currentFilter;
    return !equals(DEFAULT_FILTER_DATA, data) && !equals(DEFAULT_DATE_FILTER_DATA, data);
  };

  setTouched = () => this.setState({ touched: true });

  handleOnClearClick = () => {
    this.props.setFilterDataByFilterName(this.props.currentFilter.name, DEFAULT_FILTER_DATA);
    this.setTouched();
  };

  handleOnCloseModal = () => this.props.animateModalByFilterName(DEFAULT_FILTER_NAME);

  renderHeaderContent = renderWhenTrue(() => (
    <Fragment>
      <Heading>{this.props.currentFilter.name}</Heading>
      <Controls>
        {renderWhenTrueOtherwise(
          () => (
            <Fragment>
              <Control message={messages.clear} onClick={this.handleOnClearClick} />
              <Control primary message={messages.done} onClick={this.handleOnCloseModal} />
            </Fragment>
          ),
          () => (
            <Fragment>
              {renderWhenTrue(() => <Control message={messages.clear} onClick={this.handleOnClearClick} />)(
                this.getIsClearButtonVisible()
              )}
              <Control primary message={messages.close} onClick={this.handleOnCloseModal} />
            </Fragment>
          )
        )(this.state.touched)}
      </Controls>
    </Fragment>
  ));

  renderContent = cond([
    [equals(FilterNames.LOCATION), () => <FilterModalLocation setTouched={this.setTouched} />],
    [equals(FilterNames.ACTIVITIES), () => <FilterModalActivities setTouched={this.setTouched} />],
    [equals(FilterNames.GUESTS), () => <FilterModalGuests setTouched={this.setTouched} />],
    [equals(FilterNames.DATE), () => <FilterModalDatePicker setTouched={this.setTouched} />],
    [T, always(null)],
  ]);

  render() {
    return (
      <ModalOverlay
        totalDuration={FADE_IN_UP_TRANSITION_TOTAL_DURATION}
        isVisible={this.props.isModalVisible}
        onHideRequest={this.handleOnCloseModal}
      >
        <Dialog filterName={this.props.currentFilterName} className={this.props.className}>
          <Header>{this.renderHeaderContent(!isEmpty(this.props.currentFilterName))}</Header>
          <BodyScrollLock>
            <ScrollContent>
              <Content extraStyle={this.props.contentStyle}>{this.renderContent(this.props.currentFilterName)}</Content>
            </ScrollContent>
          </BodyScrollLock>
        </Dialog>
      </ModalOverlay>
    );
  }
}
